export default __webpack_public_path__ + "static/media/CC.f2c03707.png";